<!--     Contact Us      -->
<div class="contactus-1 section-image" style="background-image: url('./assets/img/city.jpg')">
    <div class="container">
      <div class="row">
        <div class="col-md-5">
          <h2 class="title">{{ strTitle }}</h2>
          <h5 class="description">Tell us a little bit more about yourself so our Customer Success team can ensure we provide you with the best information to accelerate your compliance modernization journey.</h5>
          <div class="info info-horizontal">
            <div class="icon icon-primary">
              <i class="fas fa-newspaper 2x"></i>
            </div>
            <div class="description">
              <h4 class="info-title">Keep in Touch</h4>
              <p style="color: white;"> By proceeding, you agree to receive periodic communications about RegScale.  Communications will include tips and tricks, product announcements, newsletters, and other useful information to assist you with building out your new digital core for modernizing your organization's compliance processes.  RegScale will not share your information with any third party under any circumstances.  You may opt out at anytime.
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-5 ml-auto">
          <div *ngIf="strGate == 'download'">
            <iframe src="https://go.regscale.com/l/999611/2022-11-07/296d" width="100%" height="1000" type="text/html" frameborder="0" allowTransparency="true" style="border: 0" scrolling="no"></iframe>
          </div>
          <div *ngIf="strGate == 'appliance'">
            <iframe src="https://go.regscale.com/l/999611/2022-11-04/283h" width="100%" height="1000" type="text/html" frameborder="0" allowTransparency="true" style="border: 0" scrolling="no"></iframe>
          </div>
          <div *ngIf="strGate == 'sandbox'">
            <iframe src="https://go.regscale.com/l/999611/2022-10-19/l77" width="100%" height="1000" type="text/html" frameborder="0" allowTransparency="true" style="border: 0" scrolling="no"></iframe>
          </div>
        </div>
      </div>
    </div>
   </div>
